var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00315d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-12096.717-147.334l-6.283-6.074-6.281,6.074a.926.926,0,0,1-1.021.278,1.109,1.109,0,0,1-.685-.9,1.213,1.213,0,0,1,.4-1.1l6.158-5.962-6.158-5.965a1.237,1.237,0,0,1-.3-1.276,1.019,1.019,0,0,1,.967-.741.957.957,0,0,1,.645.286l6.281,6.082,6.283-6.082a.949.949,0,0,1,.645-.286,1.02,1.02,0,0,1,.967.741,1.239,1.239,0,0,1-.3,1.276l-6.161,5.965,6.161,5.962a1.22,1.22,0,0,1,.4,1.1,1.106,1.106,0,0,1-.684.9.9.9,0,0,1-.311.056A.953.953,0,0,1-12096.717-147.334Z",
    transform: "translate(12111 163.001)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0d32c2cb.svg";
export { ForwardRef as ReactComponent };